import { Space, Typography } from "antd";

type Props = {
  title?: string | null;
  value?: string | null;
};

export const EntityDetailsFieldValue = ({ title, value }: Props) => {
  return (
    <Space direction="vertical" size={0}>
      <Typography.Text type="secondary">{title}</Typography.Text>
      <Typography.Text>{value || "-"}</Typography.Text>
    </Space>
  );
};
